"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How do I know my cards were actually delivered?",
  answer: "We utilize the USPS Every Door Direct Mail (EDDM) service, which provides official documentation and mailing receipts for every campaign. Additionally, each postcard includes a unique QR code that allows you to track engagement and scans in real-time as they arrive in mailboxes."
}, {
  question: "Can I choose a specific neighborhood or route?",
  answer: "Yes. We strategically select USPS routes that target high-income households in Metro Atlanta. Currently, we focus on premium neighborhoods in Johns Creek, GA. You can view our specific coverage maps and household counts to ensure your message reaches your ideal local audience."
}, {
  question: "What does 'co-op' mailing mean for my business?",
  answer: "Co-op mailing allows you to share the cost of a premium, oversized postcard with a curated group of non-competing local businesses. This 'Modern Southern Prestige' approach ensures you get high-end visibility at a fraction of the cost of a solo mailing campaign."
}, {
  question: "Do you handle the ad design and printing?",
  answer: "Absolutely. Our full-service approach includes custom professional design that aligns with your brand, high-quality printing on premium cardstock, and complete USPS logistics. You simply provide your logo and offer, and we handle the rest."
}, {
  question: "How many households will receive my postcard?",
  answer: "Each of our standard mailing cycles is delivered directly to 2,500+ targeted households. This volume is optimized to provide significant local reach while maintaining the exclusivity and high-response rates associated with premium direct mail."
}];
export default function CommonQuestions() {
  return <section data-section-id="224143" id="common-questions" className="w-full py-16 md:py-24 bg-muted text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-secondary mb-4 tracking-tight">
            Common Questions
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Everything you need to know about launching your premium direct mail campaign in Metro Atlanta.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="bg-card border border-border rounded-md px-4 shadow-sm transition-shadow hover:shadow-md">
              <AccordionTrigger className="font-default font-bold text-left text-base md:text-lg hover:no-underline hover:text-primary transition-colors py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5 font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}